// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9717 ? "e6b68d76" : chunkId) + "." + {"4220":"8b7f6140f83ddb03","9717":"3e582adb08d622b9"}[chunkId] + ".js";
};